import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { Component, Inject, OnInit } from '@angular/core';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ReportForAccountingDaysInMonthInfo, ReportForAccountingViewInfo } from '../model/reportForAccounting.model';
import { EmpInfo } from '../model/emp.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';
import { LookupInfo } from '../model/lookup.model';
import { ReportTimesheetSummaryInfo, ReportTimesheetSummaryViewInfo } from '../model/reportTimesheetSummary.model';
import { DatePipe, formatDate } from '@angular/common';
import { debug } from 'console';
import { last } from 'rxjs/operators';

@Component({
  selector: 'app-timesheet-summary-report',
  templateUrl: './timesheet-summary-report.component.html',
  styleUrls: ['./timesheet-summary-report.component.css']
})
export class TimesheetSummaryReportComponent implements OnInit {

  baseurl: string;

  //Primary data
  ReportView: ReportTimesheetSummaryViewInfo;

  ListMonth: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  //Search Conditions
  ListEmployeeCode: string[] = [];

  txtSchEmployee: string = "";
  txtSchYear: string = "";
  txtSchFormat: string = "1";
  txtSchFormatCurrent: string = "1";

  txtSubmittedEmployee: EmpInfo[] = [];
  txtSubmittedYear: string = "";

  //Export
  fileName = 'TestSheet.xlsx'; 

  //empselect
  employeeselectrun: boolean = false;
  selectedemp: EmpInfo[] = [];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService) { 
    this.baseurl = environment.base_api;

    GlobalService.CheckPagingAccessRights();
  }

  // ngOnInit - start
  // ========================================================================================================
  ngOnInit(): void {
    
  }
  // ngOnInit - end
  // ========================================================================================================

  // OnEvent - start
  // ========================================================================================================
  OnSearch_Click() {
    // if(!this.txtSchEmployee || !this.txtSchYear) {
    //   alert("Please select employee and year before submit")
    //   return;
    // }

    if (!this.txtSchYear) {
      alert('Please select as of month')
      return;
    };

    this.txtSchFormatCurrent = this.txtSchFormat;

    this.LoadReport();
    this.txtSubmittedEmployee = this.selectedemp
    this.txtSubmittedYear = this.txtSchYear
  }

  OnClearSearch_Click() {
    this.txtSchYear = null;
    this.txtSchFormat = "1";
    this.txtSchEmployee = null;
    this.selectedemp = [];
    this.ReportView = null;
  }

  OnExport_Click() {
    //let element = document.getElementById('checkbox-select');
    //const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    ///* generate workbook and add the worksheet */
    //const wb: XLSX.WorkBook = XLSX.utils.book_new();

    //XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    ///* save to file */
    //XLSX.writeFile(wb, this.fileName);

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(formatDate(this.txtSchYear, 'MMM-yyyy', 'en-US'));

    // Title
    let title = 'As of Month ' + formatDate(this.txtSchYear, 'MMM-yyyy', 'en-US');

    // Add new row
    let titleRow = worksheet.addRow(["", "", "", "", title]);

    //define workdays for months
    let aboveheader = ["", ""];
    for (let month of this.ListMonth) {
      aboveheader.push(this.getWorkingDays(month))
    }

    //Add Monthly Workdays Row
    let workdayRow = worksheet.addRow(aboveheader);

    //define months header
    let header = ["Employee #", "Name"];
    for (let month of this.ListMonth) {
      header.push(month);
    }

    header.push("Remark");

    //Add Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Example Data
    //let data = [
    //  [2007, 1, "Volkswagen ", "Volkswagen Passat", 1267, 10],
    //  [2007, 1, "Toyota ", "Toyota Rav4", 819, 6.5],
    //  [2007, 1, "Toyota ", "Toyota Avensis", 787, 6.2],
    //  [2007, 1, "Volkswagen ", "Volkswagen Golf", 720, 5.7],
    //  [2007, 1, "Toyota ", "Toyota Corolla", 691, 5.4],
    //];

    // Set font, size and style in title row.
    //titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true };

    // Blank Row
    //worksheet.addRow([]);

    //Add row with current date
    //let datePipe: DatePipe = new DatePipe("en-US");
    //let subTitleRow = worksheet.addRow(['Date : ' + datePipe.transform(new Date(), 'medium')]);

    //worksheet.mergeCells('A1:D2');

    //Main Data Array
    let exportData = [];

    //Parsing and adding
    for (let empcode of this.ListEmployeeCode) {

      let newRow = [];

      newRow.push(empcode);
      newRow.push(this.getEmployeeName(empcode))

      for (let month of this.ListMonth) {

        newRow.push(this.getEmployeeWorkhoursByMonthRaw(empcode, month))

      }

      //remark
      newRow.push(this.getResignStatus(empcode));

      exportData.push(newRow)
    }

    // Add Data and Conditional Formatting
    exportData.forEach(d => {
      let row = worksheet.addRow(d);

      //for (let month of this.ListMonth) {

      //  row.

      //}

      //let qty = row.getCell(5);
      //let color = 'FF99FF99';
      //if (+qty.value < 500) {
      //  color = 'FF9999'
      //}

      //qty.fill = {
      //  type: 'pattern',
      //  pattern: 'solid',
      //  fgColor: { argb: color }
      //}

      row.eachCell((cell, number) => {

        if (number != 1 && number != 2) {
          let text = cell.text;
          const textArray = text.split("/");

          let hours = Number(textArray[0])
          let expected = Number(textArray[1])

          let percent = (hours / expected) * 100;

          let color = '';
          if (percent > 79 && percent < 100) {
            color = 'FFFF00'
          }
          if (percent < 79) {
            color = 'FF0000'
          }

          if (color != '') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: color }
            }
          }
          
        }

        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });
    });

    // Define Footer Data
    let footer = ["", ""];
    for (let month of this.ListMonth) {
      footer.push(this.getEmployeeWorkhoursByMonthTotalRaw(month));
    }

    footer.push("");

    //Add Footer Row
    let footerRow = worksheet.addRow(footer);

    footerRow.font = { bold: true };
    footerRow.eachCell((cell, number) => { cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } });

    // Blank Row between Summary
    worksheet.addRow([]);

    let totalemp = this.ListEmployeeCode.length;
    let submitcomplete = 0;
    let submitincomplete = 0;
    let notsubmit = 0;

    for (let emp of this.ListEmployeeCode) {
      let status = this.getEmployeeWorkhoursTotalStatusRaw(emp);

      if (status == 'COMPLETE') submitcomplete++;
      if (status == 'INCOMPLETE') submitincomplete++;
      if (status == 'NOTSUBMIT') notsubmit++;
    }

    // Define Summary Rows
    let totalempRow = ["", "Total Employees", this.ListEmployeeCode.length]
    let submitcompleteRow = ["", "Submitted Complete", submitcomplete]
    let submitincompleteRow = ["", "Submitted Incomplete", submitincomplete]
    let notsubmitRow = ["", "Not-Submitted", notsubmit]

    let summaryrows = [];
    summaryrows.push(totalempRow)
    summaryrows.push(submitcompleteRow)
    summaryrows.push(submitincompleteRow)
    summaryrows.push(notsubmitRow)

    // Add Summary Rows
    summaryrows.forEach(d => {
      let row = worksheet.addRow(d);

      let rowhead = row.getCell(2);
      let rowvalue = row.getCell(3);

      rowhead.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      rowvalue.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });


    // Write out file
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'TimesheetSummary' + formatDate(this.txtSchYear, 'ddMMyyyy', 'en-US') +'.xlsx');
    });
  }
  // OnEvent - end
  // ========================================================================================================

  // Primary-Data Functions - start
  // ========================================================================================================
  async LoadReport() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SearchEmployeeCode'] = this.selectedemp;
      objectjson['SearchAsOfDate'] = this.checkUndefinedString(this.txtSchYear) ? this.txtSchYear + '-01' : null;
      objectjson['SearchFormat'] = this.checkUndefinedString(this.txtSchFormat) ? this.txtSchFormat : "1";

      console.log(this.txtSchYear)

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ReportTimesheetSummaryViewInfo>(this.baseurl + "TimeSheet/GetReportTimesheetSummary",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            console.log(data)
            this.ReportView = data

            this.ListEmployeeCode = Array.from(new Set(data.ListReportTimesheetSummary.map((item: any) => item.EmployeeCode))).sort((a, b) => {
              return a >= b
                ? 1
                : -1
            });
          }
        });
    }
  }


  // Primary-Data Functions - end
  // ========================================================================================================


  // Misc functions - start
  // ========================================================================================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  getWorkingDays(ShortMonth: string) {
    return this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth)[0].Workday + ' Days';
  }

  getEmployeeName(EmpCode: string) {
    return this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmpCode)[0].EmployeeDisplay;
  }

  getEmployeeJob(EmpCode: string) {
    return this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmpCode)[0].JobDisplay;
  }

  getEmployeeWorkhoursTotal(EmpCode: string) {

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmpCode && new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth());

    let hours = rec.length > 0 ? rec.reduce((sum, current) => sum + current.Hours, 0) : 0;
    let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth()).reduce((sum, current) => sum + current.Workday, 0) * 8;

    let res = '';

    //let percent = (hours / expected) * 100;
    res = '<span>' + this.replaceCommas(hours) + '/' + this.replaceCommas(expected) + '</span>';

    return res;
  }

  getEmployeeWorkhoursTotalStatus(EmpCode: string) {

    //debugger

    //let exist = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmpCode);
    //let rec = exist.filter(x => new Date(this.txtSubmittedYear) >= new Date(x.EntryDate) && (x.ResignDate == null || new Date(this.txtSubmittedYear) <= new Date(x.ResignDate)));

    //let hours = rec.length > 0 ? rec.reduce((sum, current) => sum + current.Hours, 0) : 0;
    //let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth()).reduce((sum, current) => sum + current.Workday, 0) * 8;
    //let realexpected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(this.txtSubmittedYear) > new Date(exist[0].EntryDate) && (exist[0].ResignDate == null || new Date(this.txtSubmittedYear) <= new Date(exist[0].ResignDate)) && new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSubmittedYear).getMonth()).reduce((sum, current) => sum + current.Workday, 0) * 8;

    //let res = '';


    ////let percent = (hours / expected) * 100;
    //res = '<span>' + hours + '/' + expected + '</span>';

    //if (hours != realexpected) res = '<span class=\'text-danger\'>Incompleted</span>'
    //if (hours >= realexpected) res = '<span class=\'text-success\'>Completed</span>'

    //return res;

    debugger

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmpCode);
    //let rec = exist.filter(x => new Date(this.txtSubmittedYear) >= new Date(x.EntryDate) && (x.ResignDate == null || new Date(this.txtSubmittedYear) <= new Date(x.ResignDate)));

    let expectedmonths = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth())

    let pass = true;
    for (let month of expectedmonths) {
      let considered = this.checkIfCount(EmpCode, this.ListMonth[new Date(month.TimeSheetDate).getMonth()]) != '' ? false : true
      if (!considered) continue;

      let selectedmonth = rec.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == this.ListMonth[new Date(month.TimeSheetDate).getMonth()])
      let hours = selectedmonth.length > 0 ? selectedmonth.reduce((sum, current) => sum + current.Hours, 0) : 0;
      let expected = month.Workday * 8;

      if (hours < expected) pass = false;
    }

    let res = '';

    if (!pass) res = '<span class=\'text-danger\'>Incompleted</span>'
    if (pass) res = '<span class=\'text-success\'>Completed</span>'

    return res;
  }

  getEmployeeWorkhoursTotalStatusRaw(EmpCode: string) {

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmpCode && new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth());

    //let hours = rec.length > 0 ? rec.reduce((sum, current) => sum + current.Hours, 0) : 0;
    //let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth()).reduce((sum, current) => sum + current.Workday, 0) * 8;

    let arrayofmonth = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth());

    let complete = 0;
    let incomplete = 0;
    let notsubmit = 0;

    for (let month of arrayofmonth) {
      let considered = this.checkIfCount(EmpCode, this.ListMonth[new Date(month.TimeSheetDate).getMonth()]) != '' ? false : true
      if (!considered) continue;

      let data = rec.filter(x => new Date(x.TimeSheetDate).getMonth() == new Date(month.TimeSheetDate).getMonth());

      let va = data != null && data.length > 0 ? data[0].Hours : 0;
      let ex = month.Workday * 8;

      if (va == 0) {
        notsubmit++;
        continue;
      };
      if (va >= ex) {
        complete++;
        continue;
      };
      if (va != ex) {
        incomplete++;
        continue;
      };
      
      

    }


    let res = '';

    //let percent = (hours / expected) * 100;
    //res = '<span>' + hours + '/' + expected + '</span>';

    //if (hours != expected) res = 'INCOMPLETE'
    //if (hours >= expected) res = 'COMPLETE'
    //if (hours == 0) res = 'NOTSUBMIT'

    if (incomplete == 0 && notsubmit == 0) res = 'COMPLETE'
    if (incomplete > 0 || notsubmit > 0) res = 'INCOMPLETE'
    if (incomplete == 0 && complete == 0 && notsubmit > 0) res = 'NOTSUBMIT'

    return res;
  }

  getEmployeeWorkhoursByMonth(EmployeeCode: string, ShortMonth: string) {

    //debugger

    if (new Date(this.txtSchYear).getMonth()  < ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(ShortMonth) / 3 )) return '';

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmployeeCode && this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth);

    let hours = rec.length > 0 ? rec[0].Hours : 0;
    let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth)[0].Workday * 8;

    let res = '';

    let percent = (hours / expected) * 100;
    res = '<span>' + hours + '/' + expected + '</span>';
    let considered = this.checkIfCount(EmployeeCode, ShortMonth) != '' ? false : true;

    if (percent > 79 && percent < 100 && considered) res = '<span class=\'text-warning\'>' + hours + '/' + expected + '</span>'
    if (percent < 79 && considered) res = '<span class=\'text-danger\'>' + hours + '/' + expected + '</span>'

    if (hours == 0 && !considered) {
      res = '-'
    }

    return res;
  }

  checkIfCount(EmployeeCode: string, ShortMonth: string) {

    //debugger

    let res = ''
    let exist = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmployeeCode);
    let checkentry = exist.filter(x => new Date(this.formatDate(ShortMonth, this.txtSubmittedYear, true)) > new Date(x.EntryDate));
    let checkresign = exist.filter(x => new Date(this.formatDate(ShortMonth, this.txtSubmittedYear, false)) < new Date(x.ResignDate));
    if ((checkentry == null || checkentry.length <= 0)) res = '-';
    if ((checkresign == null || checkresign.length <= 0) && this.getResignStatus(EmployeeCode) != '') res = '-';
    return res;
  }

  formatDate(ShortMonth: string, Year: string, min: boolean) {
    let date = new Date(Year).getFullYear() + '-' + (this.ListMonth.indexOf(ShortMonth) + 1).toString().padStart(2, '0')
    let lastday = new Date(new Date(Year).getFullYear(), this.ListMonth.indexOf(ShortMonth) + 1, 0).getDate()

    let day = (min) ? '1' : lastday
    return date+'-'+day;
  } 

  getEmployeeWorkhoursByMonthRaw(EmployeeCode: string, ShortMonth: string) {

    if (new Date(this.txtSchYear).getMonth() < ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(ShortMonth) / 3)) return '';

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == EmployeeCode && this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth);

    let hours = rec.length > 0 ? rec[0].Hours : 0;
    let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth)[0].Workday * 8;

    let res = '';

    res = hours + '/' + expected;

    return res;
  }



  getEmployeeWorkhoursByMonthTotal(ShortMonth: string) {

    if (new Date(this.txtSchYear).getMonth() < ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(ShortMonth) / 3)) return '';

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth);

    let hours = rec.length > 0 ? rec.reduce((sum, current) => sum + current.Hours, 0) : 0;
    let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth).reduce((sum, current) => sum + current.Workday, 0) * 8 * this.ListEmployeeCode.length;

    let res = '';

    //let percent = (hours / expected) * 100;
    res = '<span>' + this.replaceCommas(hours) + '/' + this.replaceCommas(expected) + '</span>';

    return res;
  }

  getEmployeeWorkhoursByMonthTotalRaw(ShortMonth: string) {

    if (new Date(this.txtSchYear).getMonth() < ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(ShortMonth) / 3)) return '';

    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth);

    let hours = rec.length > 0 ? rec.reduce((sum, current) => sum + current.Hours, 0) : 0;
    let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth).reduce((sum, current) => sum + current.Workday, 0) * 8 * this.ListEmployeeCode.length;

    let res = '0';

    //let percent = (hours / expected) * 100;
    res = this.replaceCommas(hours);

    return res;
  }

  getEmployeeWorkhoursAllTotal() {

    let hours = this.ReportView.ListReportTimesheetSummary.length > 0 ? this.ReportView.ListReportTimesheetSummary.reduce((sum, current) => sum + current.Hours, 0) : 0;
    let expected = this.ReportView.ListReportTimesheetSummaryWorkdayInMonths.filter(x => new Date(x.TimeSheetDate).getMonth() <= new Date(this.txtSchYear).getMonth()).reduce((sum, current) => sum + current.Workday, 0) * 8 * this.ListEmployeeCode.length;

    let res = '';

    //let percent = (hours / expected) * 100;
    res = '<span>' + this.replaceCommas(hours) + '/' + this.replaceCommas(expected) + '</span>';

    return res;
  }

  getResignStatus(empcode) {
    let rec = this.ReportView.ListReportTimesheetSummary.filter(x => x.EmployeeCode == empcode && (x.ResignDate != null && x.ResignDate != ''));

    let res = (rec != null && rec.length > 0) ? 'Resign': '';

    return res;
  }


  replaceCommas(number) {
    var result = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //if (result.indexOf('.') < 0) {
    //  result += ".00";
    //}

    return result;
  }

  // Misc functions - end
  // ========================================================================================================


  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event;
    console.log(this.selectedemp)


  }

  empselect() {
    this.employeeselectrun = true;
    this.txtSchEmployee = ""
    this.selectedemp = [];
    this.ReportView = null;
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {

    $('#ModalEmpSelect').modal('hide');
    this.employeeselectrun = false;

    this.txtSchEmployee = this.selectedemp.length + ' employee(s) selected'

    
    //if (this.selectedemp != null) {
    //  // hide modal Assign PM
    //  $('#ModalEmpSelect').modal('hide');
    //  this.employeeselectrun = false;


    //  this.onChanges(this.employeeselectreturnto, true, true)

    //  this.selectedemp = null;

    //} else {
    //  alert("Please select an employee")
    //}

  }
}
